const VueAxiosPlugin = {}
export default VueAxiosPlugin.install = function(Vue, { axios }) {
  try {
    const csrf_token = document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute('content')

    axios.defaults.headers.common = {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': csrf_token
    }
  } catch (e) {
    // test 環境ではCSRFトークンを生成しないため、エラーを出力して後続処理を継続する
    console.log(e)
  }

  Vue.axios = axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return axios
      }
    }
  })
}
